<fullscreen-page>
  <content-column>
    <div class="d-flex flex-column flex-fill w-100 mx-auto overflow-hidden" slot="content">
      <div class="d-flex flex-column np-header">
        <div class="np-detail-title-row">
          <dx-button
            class="np-detail-back-btn"
            icon="chevronleft"
            stylingMode="text"
            (onClick)="goBack()"
          ></dx-button>
          <div class="np-detail-title text-truncate">
            {{ containerTitle | translate }}
          </div>
          <dx-select-box
            *ngIf="allContainers.length > 1"
            [dataSource]="allContainers"
            [value]="container?.id"
            displayExpr="name"
            valueExpr="id"
            stylingMode="outlined"
            [width]="220"
            placeholder="{{ 'Container wechseln' | translate }}"
            (onValueChanged)="onContainerSwitched($event)"
          ></dx-select-box>
        </div>

        <div class="d-flex flex-row p-2 align-items-center gap-2">
          <dx-button
              (onClick)="openCreateCatalogsPopup()"
              stylingMode="outlined"
              text="{{ 'Katalog importieren' | translate }}"
              type="default"
          >
          </dx-button>

          <div class="flex-grow-1"></div>

          <dx-button
              (onClick)="startTransportCatalogFromImportToPreparationStageJob()"
              [disabled]="!container?.activeCatalogId"
              stylingMode="outlined"
              text="{{ 'Transfer zur Preparation' | translate }}"
              type="default"
          >
          </dx-button>

          <dx-text-box
              (onValueChanged)="onSearchChanged($event)"
              [(value)]="containerSearchText"
              [showClearButton]="true"
              [width]="240"
              mode="search"
              placeholder="{{ 'Katalog suchen' | translate }}"
          >
          </dx-text-box>
        </div>
      </div>

      <np-container-import
          *ngIf="isImportPopupVisible"
          [(visible)]="isImportPopupVisible"
          [containerId]="container?.id"
          [lastCatalogName]="lastCatalogName"
          (importCompleted)="onImportCompleted()"
      >
      </np-container-import>

      <div class="d-flex flex-row flex-grow-1 min-vh-0" style="min-height: 0; overflow: hidden;">
        <div class="flex-grow-1 h-100 p-3 catalog-tabpanel-host">
          <div *ngIf="isLoading" class="p-3 text-muted">
            {{ 'Lade Katalog-Container...' | translate }}
          </div>
          <div *ngIf="!isLoading && !container" class="p-3 text-danger">
            {{ 'Katalog-Container nicht gefunden.' | translate }}
          </div>

          <dx-tab-panel
              *ngIf="!isLoading && container"
              [animationEnabled]="true"
              [swipeEnabled]="false"
              iconPosition="start"
              stylingMode="primary"
              width="100%"
              itemTitleTemplate="tabTitle"
          >
            <div *dxTemplate="let data of 'tabTitle'"
                 [style.pointer-events]="data.disabled ? 'auto' : null"
                 [attr.title]="data.disabled ? ('Bitte zuerst einen Katalog für die Preparation-Phase und einen Golden-Record festlegen.' | translate) : null">
              <i *ngIf="data.icon" class="dx-icon dx-icon-{{ data.icon }}"></i>
              <span>{{ data.title }}</span>
              <i *ngIf="data.disabled"
                 class="bi bi-exclamation-triangle"
                 style="margin-left: 6px; color: #d9534f;"></i>
            </div>

            <dxi-item [title]="'Kataloge' | translate" icon="floppy">
              <div *dxTemplate class="catalog-tab-fill">
                <np-catalog-tab
                    [container]="container"
                    [initialSelectedCatalogId]="selectedCatalogId"
                    (inspectCatalog)="onInspectCatalogRequested($event)"
                    (openImportPopupRequested)="openCreateCatalogsPopup()"
                >
                </np-catalog-tab>
              </div>
            </dxi-item>

            <dxi-item [title]="'Mappings' | translate" icon="comment" [disabled]="!canConfigureContainer">
              <div *dxTemplate class="mapping-tabpanel-host">
                <dx-tab-panel>
                  <dxi-item [title]="'Hersteller' | translate">
                    <np-manufacturer-mapping-tab
                        [container]="container">
                    </np-manufacturer-mapping-tab>
                  </dxi-item>
                  <dxi-item [title]="'Kategorien' | translate">
                    <np-category-mapping-tab
                        [container]="container"
                    ></np-category-mapping-tab>
                  </dxi-item>
                  <dxi-item [title]="'Andere' | translate">
                    <np-others-mapping-tab
                        [container]="container">
                    </np-others-mapping-tab>
                  </dxi-item>
                </dx-tab-panel>
              </div>
            </dxi-item>

            <dxi-item [title]="'Workflow' | translate" [disabled]="!canConfigureContainer">
              <div *dxTemplate>
                <np-dataprocess-workflow [container]="container"></np-dataprocess-workflow>
              </div>
            </dxi-item>
          </dx-tab-panel>
        </div>

        <np-inspect-panel
            (containerSaved)="onContainerSaved(container)"
            [container]="container"
            [context]="inspectContext"
            [catalogId]="selectedCatalogId">
        </np-inspect-panel>

      </div>
    </div>
  </content-column>
</fullscreen-page>
